var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ban-form',{attrs:{"title":"Edit Ban","ban":_vm.ban},on:{"addban":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }